import { Box, Flex, Text } from '@chakra-ui/react';
import { CheckIcon } from '@chakra-ui/icons';
import { useNavigate } from 'react-router';

export type CheckoutStep = 1 | 2 | 3;

const STEPS: { id: CheckoutStep; label: string }[] = [
  { id: 1, label: 'Offre' },
  { id: 2, label: 'Paiement' },
  { id: 3, label: 'Confirmation' },
];

/**
 * Fil d'Ariane en 3 étapes (maquette Daphné). Étape 1 « Offre » = la page
 * Tarifs, cochée et cliquable pour y revenir. Étape 3 « Confirmation » est
 * rendue dans cette même page après le paiement.
 */
export function Stepper({ current }: { current: CheckoutStep }) {
  const navigate = useNavigate();
  return (
    <Flex className="CheckoutV2Stepper" align="flex-start" w="full" maxW="460px" minW={{ base: 0, sm: '340px' }}>
      {STEPS.map((step, index) => {
        const done = step.id < current;
        const active = step.id === current;
        const clickable = step.id === 1 && current === 2;
        const circle = (
          <Box className={`cv2-step${active ? ' cv2-step--active' : done ? ' cv2-step--done' : ''}`}>{done ? <CheckIcon boxSize="11px" /> : step.id}</Box>
        );
        return (
          <Flex key={step.id} align="center" flex={index === STEPS.length - 1 ? '0 0 auto' : '1 1 0'} minW={0}>
            <Flex direction="column" align="center" flexShrink={0}>
              {clickable ? (
                <button type="button" className="cv2-step-btn" title="Revenir au choix de l'offre" onClick={() => navigate('/tarifs')}>
                  {circle}
                </button>
              ) : (
                circle
              )}
              <Text className={`cv2-step-label${active ? ' cv2-step-label--active' : ''}`}>{step.label}</Text>
            </Flex>
            {index < STEPS.length - 1 && <Box className={`cv2-step-line${done ? ' cv2-step-line--done' : ''}`} mt="-22px" />}
          </Flex>
        );
      })}
    </Flex>
  );
}

/** En-tête de page : « ÉTAPE 2 / 3 » + grand titre, fil d'Ariane à droite. */
export function PageHeader({ current, title, wide }: { current: CheckoutStep; title: string; wide: boolean }) {
  return (
    <Flex className="CheckoutV2PageHeader" direction={wide ? 'row' : 'column'} align={wide ? 'flex-end' : 'flex-start'} justify="space-between" gap={wide ? 10 : 7}>
      <Box>
        <Text className="cv2-eyebrow cv2-eyebrow--accent">Étape {current} / 3</Text>
        <Text as="h2" className="cv2-page-title">
          {title}
        </Text>
      </Box>
      <Box w={wide ? '400px' : 'full'} flexShrink={0} pb={wide ? 2 : 0}>
        <Stepper current={current} />
      </Box>
    </Flex>
  );
}
